var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _g2, _path8, _path9, _g3, _path0, _path1, _g4, _path10, _path11, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeaderLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 34,
    viewBox: "0 0 66 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.6581 27.5293L47.6673 27.5078L47.6406 27.5113L47.6581 27.5293Z",
    fill: "#004B84"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0407 22.9059C31.0268 30.141 38.3395 37.5405 46.3589 30.0997L40.2007 23.9317C39.2327 23.0835 38.2976 22.1732 37.4315 21.3102C36.3325 20.2148 35.1173 18.891 33.8257 17.547V17.5458C30.7209 14.3135 27.1797 10.9585 23.7457 10.3571C16.8337 9.14753 4.32322 24.3603 0.03125 32.0147C10.0224 24.4816 15.4727 14.032 24.0407 22.9059Z",
    fill: "#DC241B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.1166 14.7302C44.9182 6.24941 32.7594 -7.99929 25.0078 8.42381H25.0095C31.2593 -2.66496 51.5898 42.1688 65.2055 27.5L53.1166 14.7302Z",
    fill: "#E45C16"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4176 20.782C26.3668 9.43479 34.7818 31.8195 45.5203 30.0926L39.6217 24.1842C38.6652 23.3467 37.7505 22.4562 36.845 21.5573C35.6237 20.3383 34.4515 19.0561 33.2546 17.8071L33.2354 17.7879C30.6866 15.1328 26.8965 11.3139 23.3236 10.6889C21.0238 10.2857 18.2703 11.8709 16.4296 13.1634C15.0388 14.1558 13.7184 15.2433 12.4779 16.4182C11.1147 17.6896 9.81485 19.0407 8.56647 20.4364C6.80007 22.4128 5.11815 24.4964 3.54605 26.6518C2.58874 27.9647 1.64525 29.33 0.78125 30.7339C2.01178 29.7413 3.20045 28.6928 4.37357 27.622C5.8176 26.3049 7.23437 24.9497 8.69875 23.6599C9.85862 22.6014 11.1027 21.639 12.4188 20.7824",
    fill: "url(#paint0_linear_295_1898)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_295_1898",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 10,
    width: 46,
    height: 21
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.402 20.782C26.3512 9.43479 34.7661 31.8195 45.5047 30.0926L39.6061 24.1842C38.6495 23.3467 37.7348 22.4562 36.8294 21.5573C35.6081 20.3383 34.4359 19.0561 33.239 17.8071L33.2198 17.7879C30.671 15.1328 26.8809 11.3139 23.308 10.6889C21.0082 10.2857 18.2547 11.8709 16.414 13.1634C15.0231 14.1558 13.7027 15.2433 12.4623 16.4182C11.0991 17.6896 9.79923 19.0407 8.55084 20.4364C6.78444 22.4128 5.10252 24.4964 3.53043 26.6518C2.57311 27.9647 1.62963 29.33 0.765625 30.7339C1.99615 29.7413 3.18483 28.6928 4.35795 27.622C5.80198 26.3049 7.21874 24.9497 8.68313 23.6599C9.84299 22.6014 11.0871 21.639 12.4031 20.7824",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_295_1898)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.5057 9.44531H0.765625V31.8302H45.5057V9.44531Z",
    fill: "url(#paint1_linear_295_1898)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0047 23.4601C27.1518 25.674 29.3926 27.9465 31.8399 29.779C33.8983 31.3192 36.2924 32.6707 38.8427 32.8564C41.5499 33.0537 43.8731 31.8931 45.8918 30.0975C35.1534 31.8244 26.7382 9.43926 12.7891 20.7868C14.1503 19.9396 15.6078 19.3108 17.1091 19.2046C19.9198 19.0059 22.3098 20.6705 24.2526 22.6815L25.0047 23.4601Z",
    fill: "url(#paint2_linear_295_1898)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_295_1898",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 17,
    width: 34,
    height: 16
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9812 23.4757C27.1284 25.6896 29.3692 27.9622 31.8164 29.7946C33.8749 31.3348 36.2689 32.6863 38.8193 32.872C41.5265 33.0694 43.8497 31.9087 45.8683 30.1131C35.13 31.84 26.7148 9.45489 12.7656 20.8025C14.1269 19.9552 15.5844 19.3264 17.0856 19.2202C19.8963 19.0215 22.2863 20.6861 24.2292 22.6971L24.9812 23.4757Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_295_1898)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.8683 9.46094H12.7656V33.0756H45.8683V9.46094Z",
    fill: "url(#paint3_linear_295_1898)"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.7824 6.42672C36.277 0.0715237 52.3399 27.7921 64.76 27.4974L52.8976 14.965C50.8941 12.8933 48.9319 10.7838 46.8627 8.78506C44.7649 6.75754 42.4659 4.72676 40.0014 3.22935C37.9723 1.99729 35.5963 1.00215 33.2261 1.23792C30.1034 1.548 27.8885 3.92112 26.3047 6.61892C26.4576 6.53983 26.6177 6.47554 26.7828 6.42692",
    fill: "url(#paint4_linear_295_1898)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_295_1898",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 1,
    width: 39,
    height: 27
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.7746 6.44235C36.2692 0.0871487 52.3321 27.8077 64.7522 27.513L52.8898 14.9806C50.8863 12.9089 48.9241 10.7994 46.8549 8.80069C44.7571 6.77317 42.4581 4.74238 39.9936 3.24498C37.9645 2.01291 35.5885 1.01777 33.2183 1.25355C30.0956 1.56363 27.8807 3.93675 26.2969 6.63454C26.4498 6.55546 26.6098 6.49117 26.775 6.44254",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_295_1898)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.7524 0.0859375H26.2969V27.8069H64.7524V0.0859375Z",
    fill: "url(#paint5_linear_295_1898)"
  }))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.9224 19.8227C44.2633 21.2203 45.6324 22.594 47.0569 23.8964C48.3755 25.1203 49.7747 26.2544 51.2452 27.2909C53.5974 28.917 56.4785 30.3821 59.3487 30.106C61.3355 29.9154 62.9944 28.9256 64.3995 27.4866C51.9792 27.7813 35.9159 0.0603375 26.4219 6.41592C27.5672 6.07858 28.786 6.53285 29.7986 7.10367C31.1938 7.88895 32.5353 9.06015 33.7137 10.1705C35.2425 11.609 36.6968 13.1547 38.1316 14.6967C39.7252 16.4084 41.3044 18.1358 42.922 19.8231",
    fill: "url(#paint6_linear_295_1898)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_295_1898",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 5,
    width: 39,
    height: 26
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.938 19.8071C44.2789 21.2046 45.6481 22.5784 47.0725 23.8807C48.3911 25.1047 49.7903 26.2388 51.2608 27.2753C53.613 28.9014 56.4941 30.3665 59.3643 30.0904C61.3512 29.8998 63.01 28.91 64.4151 27.471C51.9948 27.7657 35.9315 0.0447125 26.4375 6.4003C27.5828 6.06295 28.8016 6.51723 29.8142 7.08804C31.2095 7.87332 32.551 9.04453 33.7293 10.1549C35.2582 11.5933 36.7124 13.1391 38.1472 14.6811C39.7408 16.3927 41.32 18.1202 42.9376 19.8075",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_295_1898)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.4147 0.0546875H26.4375V30.3757H64.4147V0.0546875Z",
    fill: "url(#paint7_linear_295_1898)"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0234 18.6879C23.5201 15.0591 29.4149 20.9435 35.1714 25.5486C29.4272 20.8394 23.5602 14.6133 16.0234 18.6879Z",
    fill: "#F1FAFC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.6953 5.52344C36.1289 6.15992 42.8533 13.1994 49.6328 19.141C42.8115 12.9569 36.0508 5.61099 30.6953 5.52344Z",
    fill: "#F1FAFC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_295_1898",
    x1: 36.8409,
    y1: 24.4197,
    x2: 18.2717,
    y2: 10.6485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC221A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F78809"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_295_1898",
    x1: 36.7813,
    y1: 26.9279,
    x2: 19.2051,
    y2: -5.49319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC221A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F78809"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_295_1898",
    x1: 18.5158,
    y1: 19.3697,
    x2: 25.7907,
    y2: 37.8588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC221A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F78809"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_295_1898",
    x1: 22.7957,
    y1: 17.7025,
    x2: 39.5695,
    y2: 35.6711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC221A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F78809"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_295_1898",
    x1: 26.3047,
    y1: 14.3514,
    x2: 64.76,
    y2: 14.3514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC221A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F78809"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_295_1898",
    x1: 43.3711,
    y1: 23.2607,
    x2: 45.4563,
    y2: 5.84903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC221A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F78809"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_295_1898",
    x1: 26.4219,
    y1: 17.8042,
    x2: 64.3995,
    y2: 17.8042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC221A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F78809"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_295_1898",
    x1: 38.2864,
    y1: 8.24136,
    x2: 52.5582,
    y2: 30.1247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC221A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F78809"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderLogo);
export default __webpack_public_path__ + "static/media/header-logo.b6d83e32524a62f0377f5b72152cfad7.svg";
export { ForwardRef as ReactComponent };